module.exports = __webpack_public_path__ + "static/vista-explodida-4-es-97b205f76635dcb87fcc2b09ba5bfa8f.png";